import { handleActions } from 'redux-actions'

const defaultState = {
  loading: false,
  searchingProducts: false,
}

exports.app = handleActions({
  TOGGLE_LOADING: (state, action) => ({
    loading: action.payload ? action.payload : !state.loading
  }),
}, defaultState)



// WEBPACK FOOTER //
// ./src/reducers/app.js